module.exports = __webpack_public_path__ + "img/logo.63dcdc32.png";